/**
 * ObservableNextQuestion — 관측 분해(제4·71·87·94류)가 지도 화면에서 아직 묻고 있는 질문 중 **지금 답할 하나**를 카드의
 *   '다음 질문' 자리에 보인다(2026-10-15). 전체 질문 목록은 2026-09-25 사용자 결정대로 지도 아래 접힘에 그대로 둔다
 *   (LED 스탠드에 의자·침구까지 늘어놓던 일) — 다만 접힘 안의 첫 질문을 사용자가 찾지 못했다(운영 실측: 제87류 '덤프트럭 캡 쇼크업소버').
 *   지도의 '호를 가르는 사실' 칸에 이미 버튼으로 그려지는 질문(mappedKeys)은 다시 올리지 않는다 — 9-25 결정과 겹치지 않게.
 *   제외 확인(류 주 목록)은 뒤로 미룬 확인이라 여기서 묻지 않는다 — 서버가 questions 에 싣지 않는다.
 */
export function observableNextQuestion(tree, mappedKeys = []) {
  if (!tree || tree.observable_derivation?.kind !== "observable_decomposition" || tree.action !== "ask") return null;
  const pfd = tree.product_fact_dialogue || {};
  const pool = Array.isArray(pfd.questions) ? pfd.questions : [];
  const skip = new Set(mappedKeys);
  const q = pool.find((x) => x && x.fact_key && !skip.has(x.fact_key) && Array.isArray(x.options) && x.options.length);
  if (!q) return null;
  const labels = q.option_labels || {};
  const options = q.options.map(String).filter((v) => v !== "undetermined").map((v) => ({ value: v, label: labels[v] || (v === "unknown" ? "모르겠습니다" : v) }));
  if (!options.length) return null;
  return { key: q.fact_key, prompt: q.prompt_ko || q.question || "", hint: q.hint || "", options };
}

export default function ObservableNextQuestion({ tree, mappedKeys = [], onAnswer, disabled = false }) {
  const qn = observableNextQuestion(tree, mappedKeys);
  if (!qn || !onAnswer) return null;
  return (
    <div data-testid="observable-next-question" style={{ marginTop: 10, padding: "10px 12px", border: "1px solid var(--audit-border, #e5e7eb)", borderRadius: 8, fontSize: 12.5, lineHeight: 1.6 }}>
      <div style={{ fontWeight: 700, marginBottom: 2 }}>다음 질문 · {qn.prompt}</div>
      {qn.hint && <div style={{ color: "var(--audit-text-muted)", marginBottom: 6 }}>{qn.hint}</div>}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
        {qn.options.map((o) => (
          <button
            key={o.value}
            type="button"
            disabled={disabled}
            onClick={() => onAnswer(qn.key, o.value)}
            style={{
              border: "1px solid var(--audit-border, #e5e7eb)", borderRadius: 999, padding: "2px 10px", fontSize: 12, cursor: "pointer",
              fontFamily: "inherit", background: "transparent", color: "var(--audit-text, #111)", textAlign: "left",
            }}
          >
            {o.label}
          </button>
        ))}
      </div>
      <div style={{ marginTop: 6, color: "var(--audit-text-muted)" }}>상품에 대해 아는 것만 답해 주세요 · 답하면 트리가 다시 계산하고 지도에 길이 이어집니다.</div>
    </div>
  );
}
